// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"39":"4fe31863","445":"12985820"}[chunkId] + ".js";
};